var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRightArrowGreen = function SvgRightArrowGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.904H.375v1.25H1v-1.25zm14.118 1.25h.625v-1.25h-.625v1.25zM1 5.154h14.118v-1.25H1v1.25z",
    fill: "#85BB65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.912 8.5-.441.443-.884-.884.442-.442.883.884zM16 4.53l.442-.443.442.442-.442.442L16 4.53zm-3.971-3.088L11.587 1l.884-.884.441.442-.883.884zm0 6.175 3.53-3.53.883.884-3.53 3.53-.883-.884zm3.53-2.646-3.53-3.53.883-.883 3.53 3.53-.884.883z",
    fill: "#85BB65"
  })));
};

export default SvgRightArrowGreen;